import {
    createStyles,
    FormControl,
    InputLabel,
    Theme,
    withStyles
} from "@material-ui/core";
import { StripeElementChangeEvent } from "@stripe/stripe-js";

import React from "react";

const styles = (theme: Theme) =>
    createStyles({
        button: { marginTop: theme.spacing(3) },
        form: {
            maxWidth: 650,
            padding: theme.spacing(8),
            width: "100%"
        },
        formElement: {
            marginBottom: theme.spacing(),
            marginTop: theme.spacing(2),
            padding: `${theme.spacing(2)}px 0 0 0`
        },
        formElementHalf: {
            "&:first-child": { marginRight: theme.spacing() },
            "&:last-child": { marginLeft: theme.spacing() },
            marginBottom: theme.spacing(),
            marginTop: theme.spacing(2),
            padding: `${theme.spacing(2)}px 0 0 0`
        },
        formFieldTop: { marginTop: 0 },
        paper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column"
        },
        sectionHeaderParagraph: { marginTop: theme.spacing(4) }
    });

interface IStripeElementWrapperProps {
    className: string;
    id: string;
    label: string;
    placeholder: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component?: any;
}

interface IStripeElementWrapperState {
    focus: boolean;
    empty: boolean;
}

class StripeElementWrapper extends React.PureComponent<
    IStripeElementWrapperProps,
    IStripeElementWrapperState
> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private component: any;

    constructor(props: IStripeElementWrapperProps) {
        super(props);
        this.state = { focus: false, empty: true };
    }

    public render() {
        const elementProps = {
            id: this.props.id,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onFocus: this.onFocus,
            onReady: this.onReady,
            options: {
                placeholder:
                    this.state.empty && this.state.focus
                        ? this.props.placeholder
                        : "",
                style: {
                    base: {
                        fontSize: "16px",
                        color: "#ffffff"
                    }
                }
            }
        };

        const style = {
            borderBottom: `${
                this.state.focus
                    ? "solid 2px rgba(247, 165, 12, 1)"
                    : "solid 1px gray"
            }`,
            marginTop: "8px",
            transition: "all 0.1s linear"
        };

        return (
            <FormControl
                className={this.props.className}
                fullWidth={true}
                onClick={this.forceFocus}
            >
                <InputLabel
                    htmlFor={this.props.id}
                    shrink={this.state.focus || !this.state.empty}
                    focused={this.state.focus}
                    color="primary"
                >
                    {this.props.label}
                </InputLabel>
                {React.createElement(this.props.component, elementProps)}
                <div style={style} />
            </FormControl>
        );
    }

    private onReady = (stripeElement: typeof this.props.component) => {
        this.component = stripeElement;
    };

    private onBlur = () => {
        this.setState((prev) => ({
            ...prev,
            focus: false
        }));
    };

    private onFocus = () => {
        this.setState((prev) => ({
            ...prev,
            focus: true
        }));
    };

    private onChange = (event: StripeElementChangeEvent) => {
        if (event.empty) {
            this.setState((prev) => ({ ...prev, empty: true }));
        } else {
            this.setState((prev) => ({ ...prev, empty: false }));
        }
    };

    private forceFocus = () => {
        if (this.component) {
            try {
                this.component.focus();
            } catch (e) {
                console.error(e);
                // Do nothing
            }
        }
    };
}

export default withStyles(styles)(StripeElementWrapper);
